'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _templateObject = _taggedTemplateLiteral(['\n  color: ', ';\n  font-family: ', ';\n  white-space: ', ';\n  opacity: ', ';\n  font-size: ', 'px;\n\n  ', ';\n'], ['\n  color: ', ';\n  font-family: ', ';\n  white-space: ', ';\n  opacity: ', ';\n  font-size: ', 'px;\n\n  ', ';\n']);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _helpers = require('../../helpers');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var Text = _styledComponents2.default.span(_templateObject, function (props) {
  return props.theme.color[props.variant];
}, function (props) {
  return props.bold ? props.theme.font.bold : props.theme.font.default;
}, function (props) {
  return props.nowrap ? 'nowrap' : 'normal';
}, function (props) {
  return props.opacity ? props.opacity : 1;
}, function (props) {
  return props.theme.size[props.size] || props.size;
}, function (props) {
  return (0, _helpers.mediaQuery)(props, 'font-size', props.size, 'size', 'px');
});

Text.displayName = 'Text';
var NitroText = function NitroText(props) {
  var className = props.className,
      children = props.children,
      variant = props.variant,
      size = props.size,
      bold = props.bold,
      opacity = props.opacity,
      desktop = props.desktop,
      nowrap = props.nowrap;


  return _react2.default.createElement(
    Text,
    {
      variant: variant,
      size: size,
      bold: bold,
      opacity: opacity,
      desktop: desktop,
      nowrap: nowrap,
      className: className
    },
    children
  );
};

NitroText.propTypes = {
  variant: _propTypes2.default.string,
  bold: _propTypes2.default.bool,
  size: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number, _propTypes2.default.object]),
  desktop: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
  opacity: _react2.default.PropTypes.string,
  nowrap: _react2.default.PropTypes.bool,
  className: _react2.default.PropTypes.string
};

exports.default = NitroText;


//////////////////
// WEBPACK FOOTER
// ./~/nitro-components/build/nitro/nitro-text/NitroText.js
// module id = 3045
// module chunks = 4